import cx from 'classnames';
import * as React from 'react';

import Image from 'components/Image';
import EngagementRatings from 'organizations/constants/EngagementRatings';

import { EngagementRating } from 'organizations/constants/EngagementRatings';

import './OrganizationEngagementBadge.scss';

type Props = {
  alt?: string | undefined;
  className?: string;
  onClick?: () => void;
  rating?: EngagementRating;
  size?: string;
};

export default function OrganizationEngagementBadge({
  alt,
  className,
  onClick,
  rating,
  size,
}: Props) {
  if (!rating) {
    return null;
  }

  return (
    <button
      className={cx(
        'OrganizationEngagementBadge',
        size && `OrganizationEngagementBadge--${size}`,
        className
      )}
      onClick={onClick}>
      <Image src={EngagementRatings.BADGES[rating].svg} alt={alt} />
    </button>
  );
}

OrganizationEngagementBadge.defaultProps = {
  alt: 'Your organization’s engagement rating badge',
  size: 'large',
};
